var _desc, _style, _g, _tspan, _tspan2, _rect, _tspan3, _tspan4, _tspan5, _rect2, _tspan6, _tspan7, _tspan8, _polygon, _rect3, _tspan9, _tspan0, _rect4, _tspan1, _tspan10, _tspan11, _rect5, _tspan12, _tspan13, _tspan14, _tspan15, _rect6, _tspan16, _tspan17, _tspan18, _tspan19, _rect7, _tspan20, _tspan21, _tspan22, _rect8, _tspan23, _tspan24, _rect9, _tspan25, _tspan26, _tspan27, _defs, _defs2, _linearGradient;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaps(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "my-svg",
    width: 672.7166748046875,
    height: 877.800048828125,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "flowchart",
    style: {
      maxWidth: "672.717px",
      backgroundColor: "transparent"
    },
    viewBox: "4 4 672.7166748046875 877.800048828125",
    role: "graphics-document document",
    "aria-roledescription": "flowchart-v2",
    "aria-describedby": "chart-desc-my-svg",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "chart-title-my-svg"
  }, "Prepare and activate a terminal map") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "chart-title-my-svg"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "chart-desc-my-svg"
  }, "Register all required sources and review operational geometry before publication.")), _style || (_style = /*#__PURE__*/React.createElement("style", null, "#my-svg{font-family:Arial,sans-serif;font-size:16px;fill:#20303a;}@keyframes edge-animation-frame{from{stroke-dashoffset:0;}}@keyframes dash{to{stroke-dashoffset:0;}}#my-svg .edge-animation-slow{stroke-dasharray:9,5!important;stroke-dashoffset:900;animation:dash 50s linear infinite;stroke-linecap:round;}#my-svg .edge-animation-fast{stroke-dasharray:9,5!important;stroke-dashoffset:900;animation:dash 20s linear infinite;stroke-linecap:round;}#my-svg .error-icon{fill:#ffffff;}#my-svg .error-text{fill:#000000;stroke:#000000;}#my-svg .edge-thickness-normal{stroke-width:1px;}#my-svg .edge-thickness-thick{stroke-width:3.5px;}#my-svg .edge-pattern-solid{stroke-dasharray:0;}#my-svg .edge-thickness-invisible{stroke-width:0;fill:none;}#my-svg .edge-pattern-dashed{stroke-dasharray:3;}#my-svg .edge-pattern-dotted{stroke-dasharray:2;}#my-svg .marker{fill:#667684;stroke:#667684;}#my-svg .marker.cross{stroke:#667684;}#my-svg svg{font-family:Arial,sans-serif;font-size:16px;}#my-svg p{margin:0;}#my-svg .label{font-family:Arial,sans-serif;color:#20303a;}#my-svg .cluster-label text{fill:#000000;}#my-svg .cluster-label span{color:#000000;}#my-svg .cluster-label span p{background-color:transparent;}#my-svg .label text,#my-svg span{fill:#20303a;color:#20303a;}#my-svg .node rect,#my-svg .node circle,#my-svg .node ellipse,#my-svg .node polygon,#my-svg .node path{fill:#edf5f8;stroke:#2e718e;stroke-width:1px;}#my-svg .rough-node .label text,#my-svg .node .label text,#my-svg .image-shape .label,#my-svg .icon-shape .label{text-anchor:middle;}#my-svg .node .katex path{fill:#000;stroke:#000;stroke-width:1px;}#my-svg .rough-node .label,#my-svg .node .label,#my-svg .image-shape .label,#my-svg .icon-shape .label{text-align:center;}#my-svg .node.clickable{cursor:pointer;}#my-svg .root .anchor path{fill:#667684!important;stroke-width:0;stroke:#667684;}#my-svg .arrowheadPath{fill:#0b0b0b;}#my-svg .edgePaths .path{stroke:#667684;stroke-width:1px;}#my-svg .flowchart-link{stroke:#667684;fill:none;}#my-svg .edgeLabel{background-color:#f8fafb;text-align:center;}#my-svg .edgeLabel p{background-color:#f8fafb;}#my-svg .edgeLabel rect{opacity:0.5;background-color:#f8fafb;fill:#f8fafb;}#my-svg .labelBkg{background-color:rgba(248, 250, 251, 0.5);}#my-svg .cluster rect{fill:#ffffff;stroke:hsl(0, 0%, 90%);stroke-width:1px;}#my-svg .cluster text{fill:#000000;}#my-svg .cluster span{color:#000000;}#my-svg .node .collapsed-indicator{fill:hsl(0, 0%, 90%);stroke:none;opacity:0.6;}#my-svg .node .collapsed-separator{stroke:hsl(0, 0%, 90%);stroke-width:0.75px;}#my-svg div.mermaidTooltip{position:absolute;text-align:center;max-width:200px;padding:2px;font-family:Arial,sans-serif;font-size:12px;background:#ffffff;border:1px solid hsl(0, 0%, 90%);border-radius:2px;pointer-events:none;z-index:100;}#my-svg .flowchartTitleText{text-anchor:middle;font-size:18px;fill:#20303a;}#my-svg rect.text{fill:none;stroke-width:0;}#my-svg .icon-shape,#my-svg .image-shape{background-color:#f8fafb;text-align:center;}#my-svg .icon-shape p,#my-svg .image-shape p{background-color:#f8fafb;padding:2px;}#my-svg .icon-shape .label rect,#my-svg .image-shape .label rect{opacity:0.5;background-color:#f8fafb;fill:#f8fafb;}#my-svg .label-icon{display:inline-block;height:1em;overflow:visible;vertical-align:-0.125em;}#my-svg .node .label-icon path{fill:currentColor;stroke:revert;stroke-width:revert;}#my-svg .node .neo-node{stroke:#2e718e;}#my-svg [data-look=\"neo\"].node rect,#my-svg [data-look=\"neo\"].cluster rect,#my-svg [data-look=\"neo\"].node polygon{stroke:url(#my-svg-gradient);filter:drop-shadow( 1px 2px 2px rgba(185,185,185,1));}#my-svg [data-look=\"neo\"].swimlane.cluster rect{filter:none;}#my-svg [data-look=\"neo\"].node path{stroke:url(#my-svg-gradient);stroke-width:1px;}#my-svg [data-look=\"neo\"].node .outer-path{filter:drop-shadow( 1px 2px 2px rgba(185,185,185,1));}#my-svg [data-look=\"neo\"].node .neo-line path{stroke:#2e718e;filter:none;}#my-svg [data-look=\"neo\"].node circle{stroke:url(#my-svg-gradient);filter:drop-shadow( 1px 2px 2px rgba(185,185,185,1));}#my-svg [data-look=\"neo\"].node circle .state-start{fill:#000000;}#my-svg [data-look=\"neo\"].icon-shape .icon{fill:url(#my-svg-gradient);filter:drop-shadow( 1px 2px 2px rgba(185,185,185,1));}#my-svg [data-look=\"neo\"].icon-shape .icon-neo path{stroke:url(#my-svg-gradient);filter:drop-shadow( 1px 2px 2px rgba(185,185,185,1));}#my-svg :root{--mermaid-font-family:Arial,sans-serif;}")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-pointEnd",
    className: "marker flowchart-v2",
    viewBox: "0 0 10 10",
    refX: 5,
    refY: 5,
    markerUnits: "userSpaceOnUse",
    markerWidth: 8,
    markerHeight: 8,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 10 5 L 0 10 z",
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 1,
      strokeDasharray: "1, 0"
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-pointStart",
    className: "marker flowchart-v2",
    viewBox: "0 0 10 10",
    refX: 4.5,
    refY: 5,
    markerUnits: "userSpaceOnUse",
    markerWidth: 8,
    markerHeight: 8,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 5 L 10 10 L 10 0 z",
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 1,
      strokeDasharray: "1, 0"
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-pointEnd-margin",
    className: "marker flowchart-v2",
    viewBox: "0 0 11.5 14",
    refX: 11.5,
    refY: 7,
    markerUnits: "userSpaceOnUse",
    markerWidth: 10.5,
    markerHeight: 14,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 11.5 7 L 0 14 z",
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-pointStart-margin",
    className: "marker flowchart-v2",
    viewBox: "0 0 11.5 14",
    refX: 1,
    refY: 7,
    markerUnits: "userSpaceOnUse",
    markerWidth: 11.5,
    markerHeight: 14,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,7 11.5,14 11.5,0",
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-circleEnd",
    className: "marker flowchart-v2",
    viewBox: "0 0 10 10",
    refX: 11,
    refY: 5,
    markerUnits: "userSpaceOnUse",
    markerWidth: 11,
    markerHeight: 11,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 1,
      strokeDasharray: "1, 0"
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-circleStart",
    className: "marker flowchart-v2",
    viewBox: "0 0 10 10",
    refX: -1,
    refY: 5,
    markerUnits: "userSpaceOnUse",
    markerWidth: 11,
    markerHeight: 11,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 1,
      strokeDasharray: "1, 0"
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-circleEnd-margin",
    className: "marker flowchart-v2",
    viewBox: "0 0 10 10",
    refY: 5,
    refX: 12.25,
    markerUnits: "userSpaceOnUse",
    markerWidth: 14,
    markerHeight: 14,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-circleStart-margin",
    className: "marker flowchart-v2",
    viewBox: "0 0 10 10",
    refX: -2,
    refY: 5,
    markerUnits: "userSpaceOnUse",
    markerWidth: 14,
    markerHeight: 14,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-crossEnd",
    className: "marker cross flowchart-v2",
    viewBox: "0 0 11 11",
    refX: 12,
    refY: 5.2,
    markerUnits: "userSpaceOnUse",
    markerWidth: 11,
    markerHeight: 11,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1,1 l 9,9 M 10,1 l -9,9",
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 2,
      strokeDasharray: "1, 0"
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-crossStart",
    className: "marker cross flowchart-v2",
    viewBox: "0 0 11 11",
    refX: -1,
    refY: 5.2,
    markerUnits: "userSpaceOnUse",
    markerWidth: 11,
    markerHeight: 11,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1,1 l 9,9 M 10,1 l -9,9",
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 2,
      strokeDasharray: "1, 0"
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-crossEnd-margin",
    className: "marker cross flowchart-v2",
    viewBox: "0 0 15 15",
    refX: 17.7,
    refY: 7.5,
    markerUnits: "userSpaceOnUse",
    markerWidth: 12,
    markerHeight: 12,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1,1 L 14,14 M 1,14 L 14,1",
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 2.5
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-crossStart-margin",
    className: "marker cross flowchart-v2",
    viewBox: "0 0 15 15",
    refX: -3.5,
    refY: 7.5,
    markerUnits: "userSpaceOnUse",
    markerWidth: 12,
    markerHeight: 12,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1,1 L 14,14 M 1,14 L 14,1",
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 2.5,
      strokeDasharray: "1, 0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "root"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "clusters"
  })), /*#__PURE__*/React.createElement("g", {
    className: "edges edgePaths"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.71666717529297,88.19999694824219L367.71666717529297,101.12892913637671Q367.71666717529297,108.19999694824219 360.6455993634275,108.19999694824219L215.78773498715844,108.19999694824219Q208.71666717529297,108.19999694824219 208.71666717529297,115.27106476010766L208.71666717529297,124.19999694824219",
    id: "my-svg-L_A_B_0",
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    style: {
      strokeDasharray: "0 0 185.67169189453125 4",
      strokeDashoffset: 0
    },
    "data-edge": "true",
    "data-et": "edge",
    "data-id": "L_A_B_0",
    "data-points": "W3sieCI6MzY3LjcxNjY2NzE3NTI5Mjk3LCJ5Ijo4OC4xOTk5OTY5NDgyNDIxOX0seyJ4IjozNjcuNzE2NjY3MTc1MjkyOTcsInkiOjEwOC4xOTk5OTY5NDgyNDIxOX0seyJ4IjoyMDguNzE2NjY3MTc1MjkyOTcsInkiOjEwOC4xOTk5OTY5NDgyNDIxOX0seyJ4IjoyMDguNzE2NjY3MTc1MjkyOTcsInkiOjEyOC4xOTk5OTY5NDgyNDIyfV0=",
    "data-look": "neo",
    markerEnd: "url(#my-svg_flowchart-v2-pointEnd-margin)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.71666717529297,204.39999389648438L186.71666717529297,217.3289260846189Q186.71666717529297,224.39999389648438 179.6455993634275,224.39999389648438L159.63773346127954,224.39999389648438Q152.56666564941406,224.39999389648438 152.56666564941406,231.47106170834985L152.56666564941406,240.39999389648438",
    id: "my-svg-L_B_C_0",
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    style: {
      strokeDasharray: "0 0 60.82167053222656 4",
      strokeDashoffset: 0
    },
    "data-edge": "true",
    "data-et": "edge",
    "data-id": "L_B_C_0",
    "data-points": "W3sieCI6MTg2LjcxNjY2NzE3NTI5Mjk3LCJ5IjoyMDQuMzk5OTkzODk2NDg0Mzh9LHsieCI6MTg2LjcxNjY2NzE3NTI5Mjk3LCJ5IjoyMjQuMzk5OTkzODk2NDg0Mzh9LHsieCI6MTUyLjU2NjY2NTY0OTQxNDA2LCJ5IjoyMjQuMzk5OTkzODk2NDg0Mzh9LHsieCI6MTUyLjU2NjY2NTY0OTQxNDA2LCJ5IjoyNDQuMzk5OTkzODk2NDg0Mzh9XQ==",
    "data-look": "neo",
    markerEnd: "url(#my-svg_flowchart-v2-pointEnd-margin)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,401.5666598786338L180,429L180,441.9289321881345Q180,449 187.07106781186548,449L230.4955978375486,449Q237.56666564941406,449 237.56666564941406,456.0710678118655L237.56666564941406,502.9289321881345Q237.56666564941406,510 244.63773346127954,510L250.92893218813452,510Q258,510 258,517.0710678118655L258,526",
    id: "my-svg-L_C_D_0",
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    style: {
      strokeDasharray: "0 0 187.77679443359375 4",
      strokeDashoffset: 0
    },
    "data-edge": "true",
    "data-et": "edge",
    "data-id": "L_C_D_0",
    "data-points": "W3sieCI6MTgwLCJ5Ijo0MDEuNTY2NjU5ODc4NjMzOH0seyJ4IjoxODAsInkiOjQyOX0seyJ4IjoxODAsInkiOjQ0OX0seyJ4IjoyMzcuNTY2NjY1NjQ5NDE0MDYsInkiOjQ0OX0seyJ4IjoyMzcuNTY2NjY1NjQ5NDE0MDYsInkiOjUxMH0seyJ4IjoyNTgsInkiOjUxMH0seyJ4IjoyNTgsInkiOjUzMH1d",
    "data-look": "neo",
    markerEnd: "url(#my-svg_flowchart-v2-pointEnd-margin)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,530L302,479.5L302,336.6999969482422L302,231.47106170834985Q302,224.39999389648438 294.9289321881345,224.39999389648438L237.78773498715844,224.39999389648438Q230.71666717529297,224.39999389648438 230.71666717529297,217.3289260846189L230.71666717529297,208.39999389648438",
    id: "my-svg-L_D_B_0",
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    style: {
      strokeDasharray: "0 0 383.5550537109375 4",
      strokeDashoffset: 0
    },
    "data-edge": "true",
    "data-et": "edge",
    "data-id": "L_D_B_0",
    "data-points": "W3sieCI6MzAyLCJ5Ijo1MzB9LHsieCI6MzAyLCJ5Ijo0NzkuNX0seyJ4IjozMDIsInkiOjMzNi42OTk5OTY5NDgyNDIyfSx7IngiOjMwMiwieSI6MjI0LjM5OTk5Mzg5NjQ4NDM4fSx7IngiOjIzMC43MTY2NjcxNzUyOTI5NywieSI6MjI0LjM5OTk5Mzg5NjQ4NDM4fSx7IngiOjIzMC43MTY2NjcxNzUyOTI5NywieSI6MjA0LjM5OTk5Mzg5NjQ4NDM4fV0=",
    "data-look": "neo",
    markerEnd: "url(#my-svg_flowchart-v2-pointEnd-margin)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.13333129882812,401.5666598786338L125.13333129882812,429L125.13333129882812,441.9289321881345Q125.13333129882812,449 118.06226348696265,449L95.07106781186548,449Q88,449 88,456.0710678118655L88,526",
    id: "my-svg-L_C_E_0",
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    style: {
      strokeDasharray: "0 0 152.2384033203125 4",
      strokeDashoffset: 0
    },
    "data-edge": "true",
    "data-et": "edge",
    "data-id": "L_C_E_0",
    "data-points": "W3sieCI6MTI1LjEzMzMzMTI5ODgyODEyLCJ5Ijo0MDEuNTY2NjU5ODc4NjMzOH0seyJ4IjoxMjUuMTMzMzMxMjk4ODI4MTIsInkiOjQyOX0seyJ4IjoxMjUuMTMzMzMxMjk4ODI4MTIsInkiOjQ0OX0seyJ4Ijo4OCwieSI6NDQ5fSx7IngiOjg4LCJ5Ijo1MzB9XQ==",
    "data-look": "neo",
    markerEnd: "url(#my-svg_flowchart-v2-pointEnd-margin)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,623.8000030517578L88,659.8000030517578",
    id: "my-svg-L_E_F_0",
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    style: {
      strokeDasharray: "0 0 32 4",
      strokeDashoffset: 0
    },
    "data-edge": "true",
    "data-et": "edge",
    "data-id": "L_E_F_0",
    "data-points": "W3sieCI6ODgsInkiOjYyMy44MDAwMDMwNTE3NTc4fSx7IngiOjg4LCJ5Ijo2NjMuODAwMDAzMDUxNzU3OH1d",
    "data-look": "neo",
    markerEnd: "url(#my-svg_flowchart-v2-pointEnd-margin)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.71666717529297,88.19999694824219L400.71666717529297,124.19999694824219",
    id: "my-svg-L_A_G_0",
    className: "edge-thickness-normal edge-pattern-dotted edge-thickness-normal edge-pattern-solid flowchart-link",
    style: {
      strokeDasharray: "0 0 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 4",
      strokeDashoffset: 0
    },
    "data-edge": "true",
    "data-et": "edge",
    "data-id": "L_A_G_0",
    "data-points": "W3sieCI6NDAwLjcxNjY2NzE3NTI5Mjk3LCJ5Ijo4OC4xOTk5OTY5NDgyNDIxOX0seyJ4Ijo0MDAuNzE2NjY3MTc1MjkyOTcsInkiOjEyOC4xOTk5OTY5NDgyNDIyfV0=",
    "data-look": "neo",
    markerEnd: "url(#my-svg_flowchart-v2-pointEnd-margin)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.71666717529297,88.19999694824219L433.71666717529297,101.12892913637671Q433.71666717529297,108.19999694824219 440.78773498715844,108.19999694824219L585.6455993634274,108.19999694824219Q592.716667175293,108.19999694824219 592.716667175293,115.27106476010766L592.716667175293,124.19999694824219",
    id: "my-svg-L_A_H_0",
    className: "edge-thickness-normal edge-pattern-dotted edge-thickness-normal edge-pattern-solid flowchart-link",
    style: {
      strokeDasharray: "0 0 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 4",
      strokeDashoffset: 0
    },
    "data-edge": "true",
    "data-et": "edge",
    "data-id": "L_A_H_0",
    "data-points": "W3sieCI6NDMzLjcxNjY2NzE3NTI5Mjk3LCJ5Ijo4OC4xOTk5OTY5NDgyNDIxOX0seyJ4Ijo0MzMuNzE2NjY3MTc1MjkyOTcsInkiOjEwOC4xOTk5OTY5NDgyNDIxOX0seyJ4Ijo1OTIuNzE2NjY3MTc1MjkzLCJ5IjoxMDguMTk5OTk2OTQ4MjQyMTl9LHsieCI6NTkyLjcxNjY2NzE3NTI5MywieSI6MTI4LjE5OTk5Njk0ODI0MjJ9XQ==",
    "data-look": "neo",
    markerEnd: "url(#my-svg_flowchart-v2-pointEnd-margin)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,757.6000061035156L88,793.6000061035156",
    id: "my-svg-L_F_I_0",
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    style: {
      strokeDasharray: "0 0 32 4",
      strokeDashoffset: 0
    },
    "data-edge": "true",
    "data-et": "edge",
    "data-id": "L_F_I_0",
    "data-points": "W3sieCI6ODgsInkiOjc1Ny42MDAwMDYxMDM1MTU2fSx7IngiOjg4LCJ5Ijo3OTcuNjAwMDA2MTAzNTE1Nn1d",
    "data-look": "neo",
    markerEnd: "url(#my-svg_flowchart-v2-pointEnd-margin)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabels"
  }, /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel",
    transform: "translate(237.12135314941406, 479.5)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "label",
    "data-id": "L_C_D_0",
    transform: "translate(0.5, -10.5)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "background",
    style: {},
    x: -16.0546875,
    y: 0,
    width: 31.109375,
    height: 21
  }), /*#__PURE__*/React.createElement("text", {
    y: -10.1,
    textAnchor: "middle",
    style: {}
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "-0.1em",
    dy: "1.1em",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "Yes"))))))), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel",
    transform: "translate(87.90234375, 479.5)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "label",
    "data-id": "L_C_E_0",
    transform: "translate(-0.05078125, -10.5)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "background",
    style: {},
    x: -35.3515625,
    y: 0,
    width: 70.8046875,
    height: 21
  }), /*#__PURE__*/React.createElement("text", {
    y: -10.1,
    textAnchor: "middle",
    style: {}
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "-0.1em",
    dy: "1.1em",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "Resolved")))))))), /*#__PURE__*/React.createElement("g", {
    className: "nodes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "node default",
    id: "my-svg-flowchart-A-0",
    "data-look": "neo",
    transform: "translate(400.71666717529297, 50.099998474121094)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "basic label-container",
    style: {},
    x: -76,
    y: -38.099998474121094,
    width: 152,
    height: 76.19999694824219
  }), /*#__PURE__*/React.createElement("g", {
    className: "label",
    style: {},
    transform: "translate(0, -26.099998474121094)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "background",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    y: -10.1,
    style: {}
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "-0.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "Complete"))), _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "related"), /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, " source"))), _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "2.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "package"))))))), /*#__PURE__*/React.createElement("g", {
    className: "node default",
    id: "my-svg-flowchart-B-1",
    "data-look": "neo",
    transform: "translate(208.71666717529297, 166.29999542236328)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "basic label-container",
    style: {},
    x: -76,
    y: -38.099998474121094,
    width: 152,
    height: 76.19999694824219
  }), /*#__PURE__*/React.createElement("g", {
    className: "label",
    style: {},
    transform: "translate(0, -26.099998474121094)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "background",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    y: -10.1,
    style: {}
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "-0.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "Process"), /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, " and"))), _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "verify"))), _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "2.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "registration"))))))), /*#__PURE__*/React.createElement("g", {
    className: "node default",
    id: "my-svg-flowchart-C-3",
    "data-look": "neo",
    transform: "translate(152.56666564941406, 336.6999969482422)"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "92.29999923706055,0 184.5999984741211,-92.29999923706055 92.29999923706055,-184.5999984741211 0,-92.29999923706055",
    className: "label-container",
    transform: "translate(-91.79999923706055, 92.29999923706055)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "label",
    style: {},
    transform: "translate(0, -17.299999237060547)"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "background",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    y: -10.1,
    style: {}
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "-0.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "Source"), /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, " or"), /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, " QA"))), _tspan0 || (_tspan0 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "gaps?"))))))), /*#__PURE__*/React.createElement("g", {
    className: "node default",
    id: "my-svg-flowchart-D-5",
    "data-look": "neo",
    transform: "translate(280, 568.0999984741211)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "basic label-container",
    style: {},
    x: -76,
    y: -38.099998474121094,
    width: 152,
    height: 76.19999694824219
  }), /*#__PURE__*/React.createElement("g", {
    className: "label",
    style: {},
    transform: "translate(0, -26.099998474121094)"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "background",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    y: -10.1,
    style: {}
  }, _tspan1 || (_tspan1 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "-0.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "Correct"), /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, " or"))), _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "explicitly"))), _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "2.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "exclude"), /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, " source"))))))), /*#__PURE__*/React.createElement("g", {
    className: "node default",
    id: "my-svg-flowchart-E-9",
    "data-look": "neo",
    transform: "translate(88, 576.9000015258789)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "basic label-container",
    style: {},
    x: -76,
    y: -46.900001525878906,
    width: 152,
    height: 93.80000305175781
  }), /*#__PURE__*/React.createElement("g", {
    className: "label",
    style: {},
    transform: "translate(0, -34.900001525878906)"
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "background",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    y: -10.1,
    style: {}
  }, _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "-0.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "Review"))), _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "proposed"))), _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "2.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "features"), /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, " and"))), _tspan15 || (_tspan15 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "3.2em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "evidence"))))))), /*#__PURE__*/React.createElement("g", {
    className: "node default",
    id: "my-svg-flowchart-F-11",
    "data-look": "neo",
    transform: "translate(88, 710.7000045776367)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "basic label-container",
    style: {},
    x: -76,
    y: -46.900001525878906,
    width: 152,
    height: 93.80000305175781
  }), /*#__PURE__*/React.createElement("g", {
    className: "label",
    style: {},
    transform: "translate(0, -34.900001525878906)"
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "background",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    y: -10.1,
    style: {}
  }, _tspan16 || (_tspan16 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "-0.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "Publish"))), _tspan17 || (_tspan17 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "reviewed"))), _tspan18 || (_tspan18 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "2.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "operational"))), _tspan19 || (_tspan19 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "3.2em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "version"))))))), /*#__PURE__*/React.createElement("g", {
    className: "node default",
    id: "my-svg-flowchart-G-13",
    "data-look": "neo",
    transform: "translate(400.71666717529297, 166.29999542236328)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "basic label-container",
    style: {},
    x: -76,
    y: -38.099998474121094,
    width: 152,
    height: 76.19999694824219
  }), /*#__PURE__*/React.createElement("g", {
    className: "label",
    style: {},
    transform: "translate(0, -26.099998474121094)"
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "background",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    y: -10.1,
    style: {}
  }, _tspan20 || (_tspan20 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "-0.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "Workbook:"))), _tspan21 || (_tspan21 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "chainage"))), _tspan22 || (_tspan22 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "2.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "context"))))))), /*#__PURE__*/React.createElement("g", {
    className: "node default",
    id: "my-svg-flowchart-H-15",
    "data-look": "neo",
    transform: "translate(592.716667175293, 157.49999618530273)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "basic label-container",
    style: {},
    x: -76,
    y: -29.299999237060547,
    width: 152,
    height: 58.599998474121094
  }), /*#__PURE__*/React.createElement("g", {
    className: "label",
    style: {},
    transform: "translate(0, -17.299999237060547)"
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "background",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    y: -10.1,
    style: {}
  }, _tspan23 || (_tspan23 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "-0.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "Imagery:"), /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, " visual"))), _tspan24 || (_tspan24 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "reference"), /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, " only"))))))), /*#__PURE__*/React.createElement("g", {
    className: "node default",
    id: "my-svg-flowchart-I-17",
    "data-look": "neo",
    transform: "translate(88, 835.7000045776367)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "basic label-container",
    style: {},
    x: -76,
    y: -38.099998474121094,
    width: 152,
    height: 76.19999694824219
  }), /*#__PURE__*/React.createElement("g", {
    className: "label",
    style: {},
    transform: "translate(0, -26.099998474121094)"
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "background",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    y: -10.1,
    style: {}
  }, _tspan25 || (_tspan25 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "-0.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "Engineering"))), _tspan26 || (_tspan26 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "geometry"))), _tspan27 || (_tspan27 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "2.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "supports"), /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, " checks")))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "my-svg-drop-shadow",
    height: "130%",
    width: "130%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 4,
    dy: 4,
    stdDeviation: 0,
    floodOpacity: 0.06,
    floodColor: "#000000"
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "my-svg-drop-shadow-small",
    height: "150%",
    width: "150%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 2,
    dy: 2,
    stdDeviation: 0,
    floodOpacity: 0.06,
    floodColor: "#000000"
  })))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "my-svg-gradient",
    gradientUnits: "objectBoundingBox",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2e718e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "hsl(200, 0%, 87.8431372549%)",
    stopOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaps);
export default __webpack_public_path__ + "static/media/maps.fdc82c298ddcd7928533ced3808b6731.svg";
export { ForwardRef as ReactComponent };